// -----------------------------------------------------------------------------
// Libraries
// -----------------------------------------------------------------------------
import React, { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';


// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { Heading1, Paragraph1 , Paragraph1l} from '../../theme/theme-provider/typography';

// -----------------------------------------------------------------------------
// Styles
// -----------------------------------------------------------------------------
import StyledRowCard from './styles';

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const RowCard = ({ rowData, setTrack, index, length, getCachedMp3 }) => {
  const [firstLoad, setFirstLoad] = useState(true);
  const  data = rowData;
  const isLoading = false;

  useEffect(() => {
    if (!isLoading && data && data.blobUrl!=null && index === length - 1 && firstLoad) {
      window.currentlyplayingindex = index;
      setTrack(data, true);
      setFirstLoad(false);
    }
  }, [index, data, isLoading, length, firstLoad, setTrack]);

  const loadNextMix = () => {
    const currentIndex = window.currentlyplayingindex;
    let nextMixIndex = (currentIndex + 1) % window.mixes.length;
    while (window.mixes[nextMixIndex].isCached !== 2) {
      nextMixIndex = (nextMixIndex + 1) % window.mixes.length;
    }
    if (window.currentlyplaying !== window.mixes[nextMixIndex].id) {
      if (window.mixes[nextMixIndex].isCached ===2) {
        // Fetch and set the cached MP3 data from IndexedDB
        if ( window.mixes[nextMixIndex].blobUrl === null) {
          getCachedMp3(window.mixes[nextMixIndex].default_url).then((cachedMp3Data) => {
            if (cachedMp3Data !== null) {
              // Set the cached MP3 data as the audio source
              window.mixes[nextMixIndex].blobUrl = cachedMp3Data;
            }
          });
        } 
      }
    }  
  };

  return (
    <StyledRowCard>
      <div className="fr-row-card">
        {isLoading && (
          <div className="fr-row-card__loading-container">
            <LoadingOutlined spin />
          </div>
        )}
        {!isLoading && data && (
          <div id={`mix_${index}`}
            className="fr-row-card__content"
            style={{ backgroundImage: `linear-gradient(  rgba(0, 0, 0, 0.5),  rgba(0, 0, 0, 0.5)),url(${data.background_image})` }}
            onClick={() => {
              let clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
              });
              if (window.currentlyplayingindex !== -1 && window.currentlyplayingindex !== index && window.mixes[window.currentlyplayingindex].isCached === 2) {
                window.mixes[window.currentlyplayingindex].blobUrl = null;
              }
              if(window.currentlyplayingindex === -1) {
                if(window.currentlyLoadedMixes>=2) {
                  // set first mix to avoid issue
                  let assigned = false;
                  let i=0;
                  do {
                    if (index !== i && window.mixes[i].isCached !==0) {
                      window.currentlyplayingindex = index;
                      let el=document.getElementById('mix_'+  i);
                      el.dispatchEvent(clickEvent);
                      assigned = true;
                      break;
                    } else {
                      i++;
                    }
                  } while (!assigned)
                  setTimeout(function(){ 
                    let el=document.getElementById('mix_'+index);
                    el.dispatchEvent(clickEvent);
                  }, 500);
                }
              } else {
                if (window.currentlyplaying !== data.id && data.isCached ===2 && data.blobUrl === null) {
                    // Fetch and set the cached MP3 data from IndexedDB
                    getCachedMp3(data.default_url).then((cachedMp3Data) => {
                      if (cachedMp3Data !== null) {
                        // Set the cached MP3 data as the audio source
                        data.blobUrl = cachedMp3Data;
                        window.currentlyplayingindex = index;
                        loadNextMix();
                        setTrack(data, false);
                      } else {
                        console.error("No cachedMp3Data found.");
                      }
                    });
                } else {
                  window.currentlyplayingindex = index;
                  if(data.isCached !==0 && window.currentlyLoadedMixes>=2) {
                    setTrack(data, false);
                    loadNextMix();
                  }
                }
              }
            }
          }
          >
            <div className="fr-row-card__content__title">
              <Heading1>{data.title}</Heading1>
              <Paragraph1>{data.dj_name}</Paragraph1>
            </div>
            <div className="fr-row-card__content__bottom">
              <Paragraph1>{data.genre_name}</Paragraph1>
              <Paragraph1l>{data.Tags.join()}</Paragraph1l>
            </div>
          </div>
        )}
      </div>
    </StyledRowCard>
  );
};

export default RowCard;
